import { getRangeForEvent, isNotNil } from 'shared/src/utils';
import type { RankingFilterState } from '../states/rankingFilter.atom';
import {
  GOODS_RANKING_SCREEN,
  getCommonFilterAnalytics,
} from './getCommonFilterAnalytics';
import type { RankingGoodsCardItem } from '../utils/convertRankingGoodsItemToGoodsData';

/**
 * DISPLAY_GOODS / CLICK_GOODS / CLICK_LIKE_GOODS / CLICK_UNLIKE_GOODS 공통 파라미터
 */
export const getGoodsAnalytics = (
  pressed: RankingGoodsCardItem,
  index: number,
  filter: RankingFilterState,
  params: { listId: string | undefined; listParams: string | undefined },
  eventType:
    | 'DISPLAY_GOODS'
    | 'CLICK_GOODS'
    | 'CLICK_LIKE_GOODS'
    | 'CLICK_UNLIKE_GOODS',
) => {
  const item = pressed.item;
  const commonFilter = getCommonFilterAnalytics(filter);

  return {
    SCREEN: GOODS_RANKING_SCREEN,
    EVENT_TYPE: eventType,
    LIST_ID: params.listId,
    LIST_INDEX: index,
    LIST_PARAMS: params.listParams,
    TYPE: commonFilter.TYPE,
    APPLIED_FILTER_TYPE: commonFilter.APPLIED_FILTER_TYPE,
    CATEGORY_SNO: item.category.sno.toString(),
    CATEGORY_NAME: item.category.name,
    CATEGORY_DEPTH: item.category.depth,
    STANDARD_CATEGORY_SNO: item.standard_category.sno.toString(),
    STANDARD_CATEGORY_NAME: item.standard_category.name,
    MARKET_SNO: item.market.sno.toString(),
    MARKET_NAME: item.market.name,
    MARKET_TYPE: item.market.market_type.name,
    GOODS_SNO: item.sno.toString(),
    GOODS_NAME: item.name,
    DELIVERY_TYPE: item.delivery_type,
    DISCOUNT_RATE: item.discount_rate,
    IS_AD: isNotNil(item.ad) ? '1' : '0',
    IS_NEW: item.is_new ? '1' : '0',
    IMAGE_BADGE_LIST: pressed.render.data.image_badge_list.map(b => b.type),
    NUDGING_DESCRIPTION: pressed.render.data.nudging_text ?? '',
    ORIGINAL_PRICE:
      item.first_page_rendering?.original_price ??
      item.linked_option.original_price,
    SALES_PRICE: item.price,
    SALES_PRICE_RANGE: getRangeForEvent({
      target: item.price,
      rangeUnit: 5000,
    }),
    REVIEW_COUNT: item.total_review_count,
    REVIEW_COUNT_RANGE: getRangeForEvent({
      target: item.total_review_count,
      rangeUnit: 50,
    }),
    REVIEW_RATING: item.positive_review_rate,
    LIKES_COUNT: null as number | null,
    LIKES_COUNT_RANGE: null as string | null,
    INDEX: index,
    ad: item.ad,
    ...pressed.logging.analytics,
  };
};
